import { Injectable } from '@angular/core';

export class SolarSystemObject {
  name: string;

  mass: number;
}

const data: SolarSystemObject[] = [{
  name: 'Enero',
  mass: 15000,
}, {
  name: 'Febrero',
  mass: 80000,
}, {
  name: 'Marzo',
  mass: 44444,
}, {
  name: 'Abril',
  mass: 67890,
}, {
  name: 'Mayo',
  mass: 13000,
}, {
  name: 'Junio',
  mass: 19900,
}, {
  name: 'Julio',
  mass: 40000,
}, {
  name: 'Agosto',
  mass: 34120,
}];

@Injectable()
export class Service {
  getData(): SolarSystemObject[] {
    return data;
  }
}
